var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"amendments-list",attrs:{"gutter":16,"type":"flex","align":"top"}},_vm._l((_vm.amendments),function(amendment){return _c('i-col',{key:amendment.id,attrs:{"span":"8"}},[_c('amendments-item',{attrs:{"amendment":amendment},on:{"edit":_vm.handleEdit}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }